import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TypedFormControl } from 'osn-shared';
import { MultiSelectOption } from '../multi-select/multi-select.component';
import { AdminUiDetailsService } from '../../../admin-ui-details/admin-ui-details.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'osn-cxb-platform-targeting-control',
  templateUrl: './platform-targeting-control.component.html',
  styleUrls: ['./platform-targeting-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformTargetingControlComponent implements OnInit, OnDestroy {
  @Input() public platformOptions: MultiSelectOption[];
  @Input() public platformIdsControl: TypedFormControl<string[]>;
  @Input() public emitValueOnRegisterOnChange = false;
  @Input('data-testid') public testId = 'platform-targeting-control-component';

  private readonly destroyed$ = new Subject<void>();
  public currentPageActions$ = this.adminUiDetailsService.currentPageActions$.pipe(takeUntil(this.destroyed$));

  constructor(private readonly adminUiDetailsService: AdminUiDetailsService) {}

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public ngOnInit(): void {}
}
